// @flow

import * as React from 'react';
import { shallowEquals } from '@ta/common.object-util';

type State = {|
  activePlayer?: Object,
  dispatch?: Function,
|};

const Context = React.createContext<State>({
  activePlayer: undefined,
  dispatch: undefined,
});

/** Redux action types for the video player */
export const ActionTypes = {
  VIDEO_VISIBLE: 'VIDEO_VISIBLE',
  VIDEO_INVISIBLE: 'VIDEO_INVISIBLE',
};

// when we have multiple videos visible at the same time we should autoplay the one that is closest to the centre
// -----screen top--------
// V1
// V2 (auto play)
// V3
// -----screen bottom--------

// if there are multiple videos at same distance to centre, so are in a row, then we play the left most one
// -----screen top--------
// V1
// V2 (auto play), V3
// V4
// -----screen bottom--------

// if a video in the same row is sligthly closer (less than 50px) to centre then ignore it and still play left most
// -----screen top--------
// V1
//                 V3
// V2 (auto play)
// V4
// -----screen bottom--------

const CENTER_POINT_THRESHOLD = 50;

const emptyState = () => Object.freeze({});

const reducer = (state: State = emptyState(), action: Object) => {
  switch (action.type) {
    case ActionTypes.VIDEO_VISIBLE:
      if (
        !state.activePlayer ||
        (state.activePlayer !== action.player && state.activePlayer.state.userInteracted)
      ) {
        return {
          ...state,
          activePlayer: action.player,
        };
      } else if (
        state.activePlayer !== action.player &&
        action.player.elemPosition + CENTER_POINT_THRESHOLD < state.activePlayer.elemPosition
      ) {
        return {
          ...state,
          activePlayer: action.player,
        };
      }
      return state;
    case ActionTypes.VIDEO_INVISIBLE:
      if (state.activePlayer === action.player) {
        return {
          ...state,
          activePlayer: undefined,
        };
      }

      return state;
    default:
      return state;
  }
};

type Props = {|
  /** Children of the VideoPlayerProvider  */
  children: React.Node,
|};

/** Component that keeps track of the currently active video player  */
export default class VideoPlayerProvider extends React.PureComponent<Props, State> {
  state = {
    activePlayer: undefined,
    dispatch: (action: Object) => {
      const newState = reducer(this.state, action);
      if (!shallowEquals(newState, this.state)) {
        this.setState(newState);
      }
    },
  };

  render() {
    const {
      state,
      props: { children },
    } = this;
    return <Context.Provider value={state}>{children}</Context.Provider>;
  }
}

/** The video player context consumer */
export const VideoPlayerConsumer = Context.Consumer;
